module.exports = __webpack_public_path__ + "img/logo.ea75a7ba.svg";